import { render } from "./Players.vue?vue&type=template&id=817f56a6"
import script from "./Players.vue?vue&type=script&lang=js"
export * from "./Players.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__